import Comp from "./Chart";

export default Comp;
